import React from 'react';

const styles = {
    container: {
        maxWidth: '800px',
        margin: '0 auto',
        padding: '40px 20px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        color: '#333',
        lineHeight: '1.7',
    },
    header: {
        textAlign: 'center',
        marginBottom: '40px',
    },
    title: {
        fontSize: '2rem',
        fontWeight: '700',
        color: '#1a1a2e',
        marginBottom: '8px',
    },
    date: {
        color: '#666',
        fontSize: '0.9rem',
    },
    section: {
        marginBottom: '28px',
    },
    h2: {
        fontSize: '1.3rem',
        fontWeight: '600',
        color: '#1a1a2e',
        marginBottom: '12px',
        borderBottom: '2px solid #e8e8e8',
        paddingBottom: '6px',
    },
    p: {
        marginBottom: '12px',
        fontSize: '0.95rem',
    },
    ul: {
        paddingLeft: '24px',
        marginBottom: '12px',
    },
    li: {
        marginBottom: '6px',
        fontSize: '0.95rem',
    },
    backLink: {
        display: 'inline-block',
        marginBottom: '20px',
        color: '#6C63FF',
        textDecoration: 'none',
        fontWeight: '500',
    },
};

export default function PrivacyPolicy() {
    return (
        <div style={styles.container}>
            <a href="/" style={styles.backLink}>← Back to OffTrigger</a>
            <div style={styles.header}>
                <h1 style={styles.title}>Privacy Policy</h1>
                <p style={styles.date}>Last updated: February 15, 2026</p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.h2}>1. Introduction</h2>
                <p style={styles.p}>
                    OffTrigger ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our lead management platform and related services.
                </p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.h2}>2. Information We Collect</h2>
                <p style={styles.p}>We collect the following types of information:</p>
                <ul style={styles.ul}>
                    <li style={styles.li}><strong>Account Information:</strong> Name, email address, and password when you register.</li>
                    <li style={styles.li}><strong>Lead Data:</strong> Contact information of leads captured through connected channels (email, Facebook Lead Ads, etc.).</li>
                    <li style={styles.li}><strong>Connected Services Data:</strong> OAuth tokens and identifiers when you connect third-party services like Gmail, Facebook, or Twilio.</li>
                    <li style={styles.li}><strong>Usage Data:</strong> Log data, device information, and usage patterns to improve our service.</li>
                </ul>
            </div>

            <div style={styles.section}>
                <h2 style={styles.h2}>3. How We Use Your Information</h2>
                <ul style={styles.ul}>
                    <li style={styles.li}>To provide, maintain, and improve our lead management services.</li>
                    <li style={styles.li}>To process and organize lead data from connected channels.</li>
                    <li style={styles.li}>To send notifications and automated responses on your behalf.</li>
                    <li style={styles.li}>To communicate with you about service updates and support.</li>
                    <li style={styles.li}>To ensure the security and integrity of our platform.</li>
                </ul>
            </div>

            <div style={styles.section}>
                <h2 style={styles.h2}>4. Facebook Data</h2>
                <p style={styles.p}>
                    When you connect your Facebook account, we access lead data from your Facebook Lead Ads through the Facebook Marketing API. We only access data you explicitly authorize, and we use it solely to display and manage your leads within OffTrigger. We do not sell or share your Facebook data with third parties.
                </p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.h2}>5. Data Storage and Security</h2>
                <p style={styles.p}>
                    Your data is stored securely using industry-standard encryption and security practices. We use Supabase for data storage with row-level security policies to ensure data isolation between users.
                </p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.h2}>6. Data Sharing</h2>
                <p style={styles.p}>
                    We do not sell, trade, or rent your personal information to third parties. We may share data only in the following circumstances:
                </p>
                <ul style={styles.ul}>
                    <li style={styles.li}>With your explicit consent.</li>
                    <li style={styles.li}>To comply with legal obligations.</li>
                    <li style={styles.li}>With service providers who assist in operating our platform (e.g., hosting providers).</li>
                </ul>
            </div>

            <div style={styles.section}>
                <h2 style={styles.h2}>7. Your Rights</h2>
                <p style={styles.p}>You have the right to:</p>
                <ul style={styles.ul}>
                    <li style={styles.li}>Access and download your personal data.</li>
                    <li style={styles.li}>Request correction of inaccurate data.</li>
                    <li style={styles.li}>Request deletion of your data.</li>
                    <li style={styles.li}>Disconnect third-party services at any time.</li>
                    <li style={styles.li}>Export your lead data in CSV format.</li>
                </ul>
            </div>

            <div style={styles.section}>
                <h2 style={styles.h2}>8. Data Retention</h2>
                <p style={styles.p}>
                    We retain your data for as long as your account is active. Upon account deletion, all associated data including leads, channel connections, and personal information will be permanently deleted within 30 days.
                </p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.h2}>9. Contact Us</h2>
                <p style={styles.p}>
                    If you have any questions about this Privacy Policy, please contact us at: <strong>ashwinoffl.project@gmail.com</strong>
                </p>
            </div>
        </div>
    );
}
